// src/pages/program/ProgramPage.jsx

import { Routes, Route } from 'react-router-dom';
import { ProgramHome } from './ProgramHome';
import { IntroductionPage } from './IntroductionPage';
import { PhaseOverviewPage } from './PhaseOverviewPage';
import { TrainingSessionsPage } from './TrainingSessionsPage';
import { SessionOverviewPage } from './SessionOverviewPage';
import { SessionPlayerPage } from './SessionPlayerPage';
import { PointsToProgressPage } from './PointsToProgressPage';
import { TestOutPage } from './TestOutPage';
import { TestOutPlayerPage } from './TestOutPlayerPage';
import { PhaseProgressPage } from './PhaseProgressPage';
import { ReturnToRunPage } from './ReturnToRunPage';
import { ExerciseBankPage } from './ExerciseBankPage';
import { OptionalOverviewPage } from './OptionalOverviewPage';
import { OptionalPlayerPage } from './OptionalPlayerPage';

export function ProgramPage() {
  return (
    <Routes>
      <Route index element={<ProgramHome />} />
      <Route path="introduction" element={<IntroductionPage />} />
      <Route path="phase/:phaseId" element={<PhaseOverviewPage />} />
      <Route path="phase/:phaseId/training" element={<TrainingSessionsPage />} />
      <Route path="phase/:phaseId/training/session/:sessionNum" element={<SessionOverviewPage />} />
      <Route path="phase/:phaseId/training/session/:sessionNum/play" element={<SessionPlayerPage />} />
      <Route path="phase/:phaseId/optional" element={<OptionalOverviewPage />} />
      <Route path="phase/:phaseId/optional/play" element={<OptionalPlayerPage />} />
      <Route path="phase/:phaseId/training/points-to-progress" element={<PointsToProgressPage />} />
      <Route path="phase/:phaseId/test-out" element={<TestOutPage />} />
      <Route path="phase/:phaseId/test-out/play" element={<TestOutPlayerPage />} />
      <Route path="phase/:phaseId/progress" element={<PhaseProgressPage />} />
      <Route path="phase/:phaseId/return-to-run" element={<ReturnToRunPage />} />
      <Route path="exercise-bank" element={<ExerciseBankPage />} />
    </Routes>
  );
}